var styleDataHash = "5482f537";
const injectCss = () => {
  var css = `@charset "UTF-8";.C15-1,.ReactModalPortal,.glob_fontElementMap,.wp5Zz,button{font-family:var(--ricos-font-family,unset)}.FQact{display:flex}[dir] ._9UEUv:hover{box-shadow:0 0 0 2px var(--ricos-focus-action-color,var(--ricos-action-color,#116dff))}[dir] .U5lWT,[dir] ._9UEUv:hover{border-radius:var(--ricos-native-whitebox-border-radius,0);cursor:default}[dir] .U5lWT{box-shadow:0 0 0 1px var(--ricos-focus-action-color,var(--ricos-action-color,#116dff))}[dir] .evkEh .U5lWT{box-shadow:none!important}.ADQS7{display:block;height:100%;position:absolute;top:0;width:100%}[dir] .ADQS7{cursor:move}[dir=ltr] .ADQS7{left:0}[dir=rtl] .ADQS7{right:0}.ADQS7.sSia0{pointer-events:none}[dir] .WLoFO ::selection{background:transparent}.tJmym{display:none}.C15-1{position:relative}.jDIC0{max-width:100%}.ReactModal__Body--open{overflow-y:hidden}.ReactModal__Content{font-weight:300}[dir=ltr] .ReactModal__Content{direction:ltr}[dir=rtl] .ReactModal__Content{direction:rtl}.ReactModalPortal{color:var(--ricos-settings-text-color,#333)}.ReactModalPortal,.ReactModalPortal input{font-family:var(--ricos-settings-text-font-family,Madefor,"Helvetica Neue",Helvetica,Arial,メイリオ,meiryo,"ヒラギノ角ゴ pro w3","hiragino kaku gothic pro",sans-serif)}.NvUDl{color:#333;text-decoration:none}.lvOvX{display:block}.D3QJM{position:relative}._8n-hX{overflow-x:auto;overflow-y:hidden}[dir=ltr] ._8n-hX,[dir=rtl] ._8n-hX{margin-left:-20px;margin-right:-20px}[dir] ._8n-hX._3ImT8::-webkit-scrollbar-thumb{background-color:rgba(0,0,0,.5)}[dir] ._8n-hX.w1q1f::-webkit-scrollbar-thumb{background-color:transparent}.m3uf8{max-width:max-content!important;min-width:100%}._8n-hX::-webkit-scrollbar{-webkit-appearance:none}[dir] ._8n-hX::-webkit-scrollbar-thumb{border:2px solid #fff;border-radius:8px}._8n-hX::-webkit-scrollbar:horizontal{height:10px}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var general_default = {
  "fontElementMap": "wp5Zz",
  "pluginContainer": "C15-1",
  "flex": "FQact",
  "isFocusable": "_9UEUv",
  "hasFocus": "U5lWT",
  "dragImageView": "evkEh",
  "overlay": "ADQS7",
  "noPointerEventsOnFocus": "sSia0",
  "hideTextSelection": "WLoFO",
  "hidden": "tJmym",
  "pluginContainerMobile": "jDIC0",
  "isImage": "NvUDl",
  "anchor": "lvOvX",
  "horizontalScrollbarWrapper": "D3QJM",
  "pluginWithHorizontalScrollbar": "_8n-hX",
  "show": "_3ImT8",
  "hide": "w1q1f",
  "horizontalScrollbar": "m3uf8"
};
export {
  general_default as default,
  injectCss
};
//# sourceMappingURL=general-scss.js.map
